export default {"src":"/_next/static/media/qualityStartups.e8e82dbe.svg","height":45,"width":47};